document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sticky-atc]').forEach(function (sticky) {
    var sectionId = sticky.dataset.section;

    // Watch the real Add to Cart button (not the whole info column) so the
    // bar reacts exactly when that button leaves or re-enters the viewport,
    // in both scroll directions.
    var trigger = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!trigger) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Only show once the button has scrolled above the viewport
          // (top < 0), not before the user has scrolled down to it.
          var scrolledPast = entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !entry.isIntersecting && scrolledPast);
        });
      },
      { threshold: 0 }
    );
    observer.observe(trigger);
  });
});
